module.exports = __webpack_public_path__ + "static/media/Belarus.8d3e9cae.png";